import initialState from "./initialState";
import axios from "axios";
import { localStorageKeys } from "@/enums/common";

const mutations = {
  setClients: (state, clients) => (state.clients = clients),
  setActiveClient: (state) => {
    const activeClient = state.clients.find(client => client._id == state.generalLocalStorageVariables.activeClientID);
    state.activeClient = activeClient ? activeClient : {}
  },
  setDataSource: (state, dataSource) => (state.dataSources.push(dataSource)),
  setDataSources: (state, dataSources) => (state.dataSources = dataSources),
  setAnalyticsGoals: (state, analyticsGoals) => (state.analyticsGoals = analyticsGoals),
  setIntegrations: (state, integrations) => (state.integrations = integrations),
  setNotifications: (state, notifications) => (state.notifications = notifications),
  setPopupData: (state, data) => {

    if (data.data) state.popups[data.popupName].data = data.data;
    state.popups[data.popupName].isPopupOpen = data.isPopupOpen;

  },
  setChartsLoadStates: (state, data) => {
    if (data.hasOwnProperty('isLoaded')) state.chartsLoadStates[data.chart].isLoaded = data.isLoaded;
    if (data.hasOwnProperty('isCalled')) state.chartsLoadStates[data.chart].isCalled = data.isCalled;
  },
  setPopupsLoadStates: (state, data) => {
    if (data.hasOwnProperty('isLoaded')) state.popupsLoadStates[data.popup].isLoaded = data.isLoaded;
    if (data.hasOwnProperty('isCalled')) state.popupsLoadStates[data.popup].isCalled = data.isCalled;
  },
  setApisLoadStates: (state, data) => {
    const apisLoadStates = { ...state.apisLoadStates };

    if (data.hasOwnProperty('isCalled')) {
      apisLoadStates[data.api] = { isCalled: data.isCalled, isLoaded: false };
    }

    if (data.hasOwnProperty('isLoaded')) {
      apisLoadStates[data.api] = { isCalled: true, isLoaded: data.isLoaded };
    }

    state.apisLoadStates = { ...apisLoadStates }
  },
  setLoaderStatus: (state, data) => {
    if (state.loaderStatus[data.name]) {

      state.loaderStatus[data.name] = { status: data.status, text: data.text };

    } else {

      const loaderStatus = { ...state.loaderStatus };
      loaderStatus[data.name] = { status: data.status, text: data.text };
      state.loaderStatus = { ...loaderStatus }

    }
  },
  resetModule: (state) => (Object.assign(state, initialState())),
  setDataSourceData: (state, data) => (state.dataSourcesData[data.key] = data.data),
  setAxiosCancelToken: (state) => {
    state.axiosCancelToken.v1 = axios.CancelToken.source()
    state.axiosCancelToken.v2 = axios.CancelToken.source();
  },
  changeNotificationStatus: (state, data) => {
    const notificationIndex = state.notifications.findIndex(notification => notification._id == data.id);
    state.notifications[notificationIndex].status = data.status;
  },
   changeGeneralLocalStorageVariables: (state, data) => {
    if (data.removeKey) {

      const { [data.key]: dynamickey, ...variables } = state.generalLocalStorageVariables;
      state.generalLocalStorageVariables = variables;

    } else {

      const allVariables = { ...state.generalLocalStorageVariables };
      allVariables[data.key] = data.value;
      state.generalLocalStorageVariables = { ...allVariables };

    }

    localStorage.setItem(localStorageKeys.heybooster, JSON.stringify(state.generalLocalStorageVariables));
  },
  removeGeneralLocalStorageVariables: (state) => {
    state.generalLocalStorageVariables = {};
    localStorage.setItem(localStorageKeys.heybooster, JSON.stringify(state.generalLocalStorageVariables));
  }
};

export default mutations;



// WEBPACK FOOTER //
// ./src/store/modules/common/mutations.js